module.exports = __webpack_public_path__ + "img/group-471.b3565f6c.svg";